const AppConsts = {
  //apiBaseUrl: "https://pstest.avaniko.com/api/",
  apiBaseUrl: "https://ps.avaniko.com/api/",
};

export default AppConsts;